import { MeterElectricIcon } from './MeterElectricIcon';

/**
 * author: Google
 * id A42A0B48-3570-4056-9745-6FEC4CE8EB8E
 * name meter-electric
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/meter-electric.svg
 * tags
 * - Home Automation 
 */
export const PowerMeterIcon = MeterElectricIcon;
export default PowerMeterIcon